import { request } from './http';
import type {
  AssistantHistoryResponse,
  AssistantInsightsResponse,
  AssistantSession,
  AssistantSessionsResponse,
  AssistantStreamCredentials,
} from './types';

export const listSessions = (): Promise<AssistantSessionsResponse> =>
  request('/assistant/sessions', 'GET');

export const createSession = (
  projectId?: string,
): Promise<{ session: AssistantSession }> =>
  request('/assistant/sessions', 'POST', { projectId });

export const getSessionMessages = (
  sessionId: string,
): Promise<AssistantHistoryResponse> =>
  request(
    `/assistant/sessions/${encodeURIComponent(sessionId)}/messages`,
    'GET',
  );

export const deleteSession = (sessionId: string): Promise<void> =>
  request(`/assistant/sessions/${encodeURIComponent(sessionId)}`, 'DELETE');

export const getStreamCredentials = (): Promise<AssistantStreamCredentials> =>
  request('/assistant/stream-token', 'POST', {});

export const listInsights = (
  projectId: string,
): Promise<AssistantInsightsResponse> =>
  request(
    `/assistant/projects/${encodeURIComponent(projectId)}/insights`,
    'GET',
  );
